import { FC, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Button } from '@/components'
import { ResponseDatasetVersion } from '@/schema'

interface DatasetVersionsCellProps {
  versions: ResponseDatasetVersion[]
}

export const DatasetVersionsCell: FC<DatasetVersionsCellProps> = ({
  versions,
}) => {
  const { t } = useTranslation()
  const [isExpanded, setIsExpanded] = useState<boolean>(false)

  const displayVersions = useMemo(
    () => (isExpanded ? versions : versions.slice(0, 3)),
    [versions, isExpanded]
  )
  const remainingCount = useMemo(() => versions.length - 3, [versions])

  if (versions.length === 0) return <span>-</span>
  return (
    <div className="flex flex-col">
      <div className="flex flex-wrap gap-1">
        {displayVersions.map((version) => (
          <div
            key={version.id}
            className="inline-flex max-h-14 items-center px-sm py-xxs rounded-sm border border-solid border-gray-300 bg-white text-sm text-gray-700 max-w-full"
          >
            <div className="truncate">{version.name}</div>
          </div>
        ))}
        {!isExpanded && remainingCount > 0 && (
          <button
            type="button"
            className="inline-flex items-center px-sm py-xxs rounded-sm bg-white text-sm text-gray-700 border border-solid border-gray-300 cursor-pointer hover:bg-gray-50 truncate"
            onClick={(e) => {
              e.stopPropagation()
              setIsExpanded(true)
            }}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault()
                e.stopPropagation()
                setIsExpanded(true)
              }
            }}
          >
            +{remainingCount}
          </button>
        )}
      </div>
      {isExpanded && displayVersions.length > 3 && (
        <div className="flex justify-end">
          <Button
            variant="text"
            color="primary"
            className="p-1 m-0 text-xs"
            onClick={(e) => {
              e.stopPropagation()
              setIsExpanded(false)
            }}
          >
            {t('common.seeLess')}
          </Button>
        </div>
      )}
    </div>
  )
}
